import React from 'react';

const VisitTourist = () => {
  const publicUrl = process.env.PUBLIC_URL + '/';

  return (
    <div className="Visa container">
      <div className="row">
        <div className="col-12">
          <p>
            En cas de difficultés administratives ou bureaucratiques, EXIFOD
            offre un soutien expert et personnalisé pour naviguer à travers les
            processus complexes de demande de visa. Son assistance va au-delà de
            simples conseils : elle inclut souvent des services de conseil sur
            les documents requis, des contacts directs avec les autorités
            consulaires, et des orientations sur les démarches à suivre pour
            maximiser les chances de succès.
          </p>
        </div>
      </div>

      {/* Tunisie */}
      <div className="tourist-section">
        <div className="row">
          <div className="col-12">
            <h2 className="section-title">Tunisie</h2>
          </div>

          {['1.webp', '2.webp', '3.webp', '4.webp'].map((img, idx) => (
            <div className="col-12 col-md-3 mb-4" key={`tunisie-${idx}`}>
              <img
                src={publicUrl + 'assets/img/' + img}
                alt={`Tunisie ${idx + 1}`}
                className="img-fluid"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Casablanca */}
      <div className="tourist-section">
        <div className="row">
          <div className="col-12">
            <h2 className="section-title">Casablanca</h2>
          </div>

          {['c1.webp', 'c2.webp', 'c3.webp', 'c4.webp'].map((img, idx) => (
            <div className="col-12 col-md-3 mb-4" key={`casa-${idx}`}>
              <img
                src={publicUrl + 'assets/img/' + img}
                alt={`Casablanca ${idx + 1}`}
                className="img-fluid"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Dubaï */}
      <div className="tourist-section">
        <div className="row">
          <div className="col-12">
            <h2 className="section-title">Dubaï</h2>
          </div>

          {['d1.webp', 'd2.webp', 'd3.webp', 'd4.webp'].map((img, idx) => (
            <div className="col-12 col-md-3 mb-4" key={`dubai-${idx}`}>
              <img
                src={publicUrl + 'assets/img/' + img}
                alt={`Dubaï ${idx + 1}`}
                className="img-fluid"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VisitTourist;
